(async () => {
    const { Core } = await importModule('Core');
    const { $show } = await importModule('Utils');

    const CN_OPEN = '!open';
    const ATTR_PLACEMENT = 'placement';


    customElements.define('localization-dropdown', class extends Core {
        elements = {
            dropdown: 'drop-down',
            form: 'form',
            spinner: '[data-spinner]'
        }

        render() {
            this._handleFormChange();
            this._handleDropdownStateChange();
            
        }

        _handleDropdownStateChange() {
            if(this.lightsOut) {
                this.$dropdown.addEventListener('dropdown:open', this._onDropdownOpen.bind(this));
                this.$dropdown.addEventListener('dropdown:close', this._onDropdownClose.bind(this));
            }
        }

        _onDropdownOpen() {
            this.publish('lights-out', true);
        }

        _onDropdownClose() {
            this.publish('lights-out', false);
        }

        _handleFormChange() {
            this.$form.addEventListener('change', this._onFormChange.bind(this))
        }

        _onFormChange() {
            $show(this.$spinner);
            try {
                const select = this.$form.querySelector('select');
                if (select && select.name === 'locale_code') {
                    const url = this._buildLocalizedUrl(select);
                    if (url) {
                        window.location.assign(url);
                        return;
                    }
                }
            } catch (e) {}
            this.$form.submit();
        }

        _buildLocalizedUrl(select) {
            const targetOption = select.selectedOptions[0];
            if (!targetOption || targetOption.dataset.rootUrl == null) return null;

            const normalize = value => (value || '/').replace(/\/+$/, '');
            const targetRoot = normalize(targetOption.dataset.rootUrl);
            const roots = [...select.options]
                .map(option => normalize(option.dataset.rootUrl))
                .filter(Boolean)
                .sort((a, b) => b.length - a.length);

            let path = window.location.pathname;
            for (const root of roots) {
                if (path === root || path.startsWith(root + '/')) {
                    path = path.slice(root.length) || '/';
                    break;
                }
            }
            if (path.charAt(0) !== '/') path = '/' + path;

            let result = (targetRoot + path).replace(/\/{2,}/g, '/');
            if (result.length > 1) result = result.replace(/\/$/, '');
            return result + window.location.search + window.location.hash;
        }

        get lightsOut() {
            return this.hasAttribute('lights-out');
        }
    });
})();